import {
  Empty,
} from 'antd';
import React, { FC } from 'react';
import NoticeSubTitleIcon from '@/assets/images/page/notice_sub_title_icon.svg?react';
import { IRelease, TypeEnum } from '@/presentation/layouts/header/notice/index';
import style from './notice-list.module.scss';

interface IProps {
  data?: IRelease;
}

export const NoticeList: FC<IProps> = (props) => {
  const { data } = props;


  if (!data || (!data?.features_data?.length && !data?.iframe_url)) {
    return <Empty description="当前无消息" />;
  }

  if (data.iframe_url) {
    return <iframe loading={'lazy'} src={data.iframe_url}
                                            className={'w-full h-[calc(100vh-143px)] rounded-[4px]'}
    />;
  }

  return <div className={style.list}>
      <div className={style.bg}>
      </div>
      <div className={'px-[20px] mt-[-320px] flex flex-col gap-[30px] pb-[20px]'}>
        {data?.features_data?.map?.((item, index) => {
          console.log(item);
          return <div key={index}>
            <div className={'flex mb-[-2px]'}>
              <div className={style.cardTitle}>
                <span>{item.title}</span>
              </div>
              <div className={style.icon}/>
            </div>
            <div className={style.card}>
              <div className={style.subCard}>
                {item?.feature_images_data?.map((featureImagesItem, index) => <div key={index}>
                  <div className={'flex items-start'}>
                    {featureImagesItem.image_description && featureImagesItem.type === TypeEnum.descriptionImage ? <div className={'w-[24px] h-[19px] mt-[3px]'}><NoticeSubTitleIcon/></div> : null}
                    {featureImagesItem.image_description && featureImagesItem.type === TypeEnum.descriptionImage ? <span className={'text-[#122440] text-[16px] font-semibold ml-[4px]'}>{featureImagesItem.image_description}</span> : null}
                  </div>
                  {featureImagesItem.image_url && featureImagesItem.type === TypeEnum.descriptionImage
                    ? <img style={featureImagesItem.image_description ? { marginTop: 12 } : undefined} src={featureImagesItem.image_url} alt="图片" className={style.img}/> : null}
                  {featureImagesItem.content && featureImagesItem.type === TypeEnum.content ? <div
                    dangerouslySetInnerHTML={{
                      __html: featureImagesItem.content,
                    }}
                  /> : null}
                </div>)}

              </div>
            </div>
          </div>;
        })}
      </div>
  </div>;
};
